import React, { useState, useEffect } from 'react';
import { BroadcastsAPI } from '../data/broadcasts';
import './BroadcastFromHQ.css';

const BroadcastFromHQ = () => {
  const [broadcasts, setBroadcasts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadBroadcasts = async () => {
    try {
      setLoading(true);
      setError('');
      const list = await BroadcastsAPI.list();
      setBroadcasts(Array.isArray(list) ? list : []);
    } catch (e) {
      setError(e?.message || String(e));
      setBroadcasts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadBroadcasts();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', { 
        month: 'short', 
        day: 'numeric', 
        year: 'numeric' 
      });
    } catch {
      return dateString;
    }
  };

  const getTypeColor = (type) => {
    switch (type?.toLowerCase()) {
      case 'announcement':
        return '#17a2b8'; // Light blue
      case 'update':
        return '#28a745'; // Green
      case 'news':
        return '#ffc107'; // Yellow
      case 'alert':
        return '#dc3545'; // Red
      default:
        return '#17a2b8'; // Default light blue
    }
  };

  return (
    <div className="broadcast-hq-container">
      <div className="broadcast-hq-header">
        <h2 className="broadcast-hq-title">Broadcast from Exodia HQ</h2>
        <p className="broadcast-hq-subtitle">
          Stay updated with the latest news, articles, and announcements
        </p>
      </div>

      <div className="broadcast-hq-controls">
        <button 
          className="refresh-button"
          onClick={loadBroadcasts}
          disabled={loading}
        >
          {loading ? 'Loading...' : 'Refresh'}
        </button>
      </div>

      <div className="broadcast-hq-content">
        {loading ? (
          <div className="loading-message">Loading broadcasts...</div>
        ) : error ? (
          <div className="error-message">Error: {error}</div>
        ) : broadcasts.length === 0 ? (
          <div className="no-broadcasts">
            <p>No broadcasts available at the moment.</p>
            <p>Check back later for updates!</p>
          </div>
        ) : (
          <div className="broadcasts-list">
            {broadcasts.map((broadcast, index) => (
              <div key={broadcast.id || index} className="broadcast-card">
                <div className="broadcast-header">
                  <span 
                    className="broadcast-type"
                    style={{ backgroundColor: getTypeColor(broadcast.type) }}
                  >
                    {broadcast.type || 'Announcement'}
                  </span>
                  <span className="broadcast-date">
                    {formatDate(broadcast.date)}
                  </span>
                </div>
                
                <h3 className="broadcast-title">
                  {broadcast.title || 'Untitled Broadcast'}
                </h3>
                
                <p className="broadcast-content">
                  {broadcast.content || 'No content available.'}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BroadcastFromHQ;
